import { SBack, STitle } from 'shj-components'
import {useParams, useSearchParams} from "react-router-dom";
import styles from './index.module.less'
import classNames from 'classnames'
import UserInfo from '@/pages/clueManage/clueDetail/components/UserInfo/UserInfo.tsx'
import TaskNode from '@/pages/clueManage/clueDetail/components/TaskNode/TaskNode.tsx'
import FollowUpRecords from '@/pages/clueManage/clueDetail/components/FollowUp/FollowUpRecord.tsx'
import NodeSteps from '@/pages/clueManage/clueDetail/components/TaskNode/NodeSteps.tsx'
import { useEffect, useRef } from 'react'
import { useSetState } from 'ahooks'
import { getClueDetail } from '@/services/saleOpServices.ts'
import ClueDetailContext from '@/pages/clueManage/clueDetail/clueDetailContext.ts'
import { Spin } from 'antd'
import { trackPlanBaseInfo } from '@/services/customerServices.ts'
import BizTypeInfo from '@/pages/clueManage/clueDetail/components/UserInfo/BizTypeInfo.tsx'
import {getTrackDetailByClueId} from "@/services/callCenter";
import { EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import authConfig from './config/authConfig';

const CustomerDetail = () => {
  const {id} = useParams()
  const [search] = useSearchParams()
  const navigate = useNavigate()
  const logRef = useRef()
  const saleClueId = search.get('saleClueId') || ''
  const templateNodeId = search.get('templateNodeId') || ''
  const authKey = search.get('authKey') || ''

  const {
    viewPhoneKey,
    editPhoneKey,
    editKey,
    isPublicSea = false,
    isWorkBench = false,
  } = authConfig(authKey)

  const [detailState, setDetailState] = useSetState<any>({
    loading: false,
    isReload: false,
    isReloadTrack: false,
    isReloadNode: false,
    isReloadRecord: false,
    isReloadTrackTab: false,
    trackDetail: {},
    templateStepId: '',
    currentTemplateStepId: '',
    templateNodeId, //当前整软定需求id
    trackTabs: [],
    isPublicSea: false, // 是否公海详情
  })

  const [trackDetail, setTrackDetail] = useSetState<any>({})

  // useEffect(() => {
  //   if (saleClueId) {
  //     getTrackInfo()
  //   }
  // }, [detailState.isReloadTrack])

  useEffect(() => {
    setDetailState({isPublicSea})
  }, [isPublicSea]);

  useEffect(() => {
    if (saleClueId || detailState.templateNodeId) getTrackInfo()
  }, [saleClueId, detailState.templateNodeId, detailState.isReloadTrack])

  useEffect(() => {
    if (id && id != 'undefined') getInfo()
  }, [id, detailState.isReload]);

  useEffect(() => {
    if (detailState.id) getTrackTabInfo(detailState.id, detailState.templateNodeId)
  }, [detailState.id, detailState.isReloadTrackTab]);

  const getTrackInfo = () => {
    trackPlanBaseInfo(saleClueId || detailState.templateNodeId).then(res => {
      // console.log('trackDetail:', res)
      setDetailState({ trackDetail: res })
      setTrackDetail(res)
    })
  }

  const getInfo = () => {
    setDetailState({loading: true})
    getClueDetail(id).then(res => {
      setDetailState({ ...res, loading: false })
    })
  }

  const getTrackTabInfo = (id, templateNodeId: any) => {
    getTrackDetailByClueId(id).then(res => {
      setDetailState({trackTabs: res})
      let current = res[0]
      if (templateNodeId) {
        current = res.find(item => item.id === templateNodeId)
      }
      setDetailState({templateStepId: current?.salesTemplateId, currentTemplateStepId: current?.currentNodeId, templateNodeId: current?.id})
    })
  }

  const updateDetail = state => {
    setDetailState({ ...state })
  }

  return (
    <>
      <ClueDetailContext.Provider value={{ detailState, updateDetail, trackDetail, viewPhoneKey, editPhoneKey, editKey, isWorkBench }}>
        <SBack
          level={2}
          title={'详情'}
          titleStyle={{ marginBottom: 10 }}
          gutter={0}
          goPath={() => {
            const params = new URLSearchParams(location.search);
            const returnUrl = params.get('returnUrl');
            if (returnUrl) {
              window.open(decodeURIComponent(returnUrl), '_self');
            } else {
              console.log('goBack')
              navigate('/saleOp/salesWorkbench/list')
            }
          }}
        >
          <Spin spinning={detailState.loading}>
            <div className={classNames([styles.flexBetweenStart, styles.detailBox])}>
              <div className={styles.colBox}>
                <UserInfo/>
              </div>
              <div className={styles.colBox} style={{ padding: '0px 15px 0 15px', overflowY: 'scroll' }}>
                {(!saleClueId && ['DESIGN', 'TO_SHOP'].includes(detailState.status)) && <BizTypeInfo />}
                <STitle style={{ marginBottom: 10, marginTop: 10 }} title={`销售计划节点（关联商机计划ID：${detailState.salesTemplateId || ''}）`} />
                <NodeSteps trackDetail={trackDetail} isReload={detailState.isReloadNode}/>
                <STitle style={{ marginBottom: 10, marginTop: 10 }} title="节点活动" />
                <TaskNode />
              </div>
              <div className={styles.colBox} style={{ padding: '10px 10px 0 10px' }}>
                <div className={styles.planTitle}>
                  <STitle style={{ width: '50%' }} title={'跟进记录'} />
                  {
                    detailState.isPublicSea ? null : (
                      <div className={styles.planText} onClick={() => logRef?.current?.onAdd()}>
                        <EditOutlined />
                        <div style={{ marginLeft: '5px' }}>填写跟进记录</div>
                      </div>
                    )
                  }
                </div>
                <FollowUpRecords ref={logRef} />
              </div>
            </div>
          </Spin>
        </SBack>
      </ClueDetailContext.Provider>
    </>
  )
}

export default CustomerDetail
